// Inventory.js
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Typography } from '@mui/material';
import { green, orange, red, yellow } from '@mui/material/colors';
import React, { useState } from 'react';
import ResourceBar from './ResourceBar';
const Inventory = ({ character, tabHeight }) => {


    const [selectedItem, setSelectedItem] = useState(null);

    const handleItemClick = (item) => {
        setSelectedItem(item);
    };

    const handleClose = () => {
        setSelectedItem(null);
    };

    const {
        inventory: { items, currency },

    } = character;

    const carrying_capacity = 50;
    const encumbrance = 25;

    const encumbrance_percent = (encumbrance / carrying_capacity) * 100;
    let encumbrance_color = red[700]; // default to overloaded
    if (encumbrance_percent < 51) {
        encumbrance_color = green[400]; // #66bb6a
    } else if (encumbrance_percent < 76) {
        encumbrance_color = yellow[700]; // #fbc02d
    } else if (encumbrance_percent < 91) {
        encumbrance_color = orange[700]; // #ef6c00
    }

    return (
        <Box
            sx={{
                height: `calc(100vh - ${tabHeight})`,
                paddingTop: '5px',
                boxSizing: 'border-box',
                overflowY: 'auto',
                p: 1,
            }}
        >

            {/* Encumbrance Section */}
            <Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
                <Typography>
                    <strong>Encumbrance:</strong> {encumbrance} / {carrying_capacity} kg
                </Typography>
                <ResourceBar value={encumbrance} max={carrying_capacity} color={encumbrance_color} />
            </Paper>

            {/* Currency Section */}
            <Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
                <Typography variant="h6">Currency</Typography>
                {currency.length > 0 ? (
                    currency.map((coin, index) => (
                        <Typography key={index}>
                            <strong>{coin.type.toUpperCase()}:</strong> {coin.amount}
                        </Typography>
                    ))
                ) : (
                    <Typography>
                        You have no currency.
                    </Typography>
                )}
            </Paper>

            {/* Items Section */}
            <Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
                <Typography variant="h6">Items</Typography>
                {items.length > 0 ? (
                    items.map((item, index) => (
                        <Typography key={index} sx={{ marginTop: 1, cursor: 'pointer' }} onClick={() => handleItemClick(item)}>
                            {item.name}
                        </Typography>
                    ))
                ) : (
                    <Typography>You have no items.</Typography>
                )}
            </Paper>

            {selectedItem && (
                <Dialog open={!!selectedItem} onClose={handleClose}>
                    <DialogTitle>{selectedItem.name}</DialogTitle>
                    <DialogContent>
                        {Object.entries(selectedItem).map(([key, value]) => (
                            value !== null && key !== 'name' && (
                                <Typography key={key}><strong>{key}:</strong> {JSON.stringify(value)}</Typography>
                            )
                        ))}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Close</Button>
                    </DialogActions>
                </Dialog>
            )}

        </Box>
    );
};

export default Inventory;
